import { Action, createReducer, on } from "@ngrx/store";

import * as MessagesActionTypes from "../../actions/messages/message.actions";
import { AppMessage } from "src/app/models/common/appMessage";
import { SnackbarData } from "src/app/models/snackbar/snackbar.model";

export interface MessagesState {
  snackbar: SnackbarData;
  appMessage: AppMessage;
  resetMessage: boolean;
  clearMessages: string;
}

export const initialState: MessagesState = {
  snackbar: null,
  appMessage: null,
  resetMessage: false,
  clearMessages: null,
};

const messagesReducer = createReducer(
  initialState,
  on(MessagesActionTypes.setSnackbar, (state, { snackbar }) => ({
    ...state,
    snackbar,
  })),
  on(MessagesActionTypes.setMessage, (state, { appMessage }) => ({
    ...state,
    appMessage,
  })),
  on(MessagesActionTypes.resetMessageFlag, (state) => ({
    ...state,
    appMessage: null,
    snackbar: null,
    resetMessage: true,
  })),
  on(MessagesActionTypes.setMessageFlag, (state) => ({
    ...state,
    appMessage: null,
    resetMessage: false,
  })),
  on(MessagesActionTypes.clearMessage, (state, { timestamp }) => ({
    ...state,
    clearMessages: timestamp,
  }))
);

export function reducer(state: MessagesState | undefined, action: Action) {
  return messagesReducer(state, action);
}
